import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGetCourseList } from '@/Module/Lesson/Model/ApiModel';
import type { ICourseV2 } from '@/Module/Lesson/Model/DataModel';
import { CourseService } from '@/Module/Lesson/Service';

export const getCourseListAction = createAsyncThunk<ICourseV2[], IGetCourseList>(
  'course/getCourseList',
  async (query, { signal }) => {
    return CourseService.getListV2(query, signal).then(({ data: { data } }) => data);
  },
);
